module.exports = __webpack_public_path__ + "src/app/_content/imgs/icons/add_options.png?ee826f54bbf54cdbb085d839c599eed7";